import BusinessIcon from '@mui/icons-material/Business';

import { ThirdPartyTypeEnum } from '@e-socna/data-layer';

import { Avatar } from '../Avatar';
import { thirdPartyTooltipOf } from '../../utils/third-party-tooltip.util';

import { getThirdPartyName } from './utils/third-party-name.util';
import type { FolderBusinessEntityListCmp_ThirdParty } from './fragments/third-party.fragment';

interface Props {
  readonly categoriesLabel: string;
  readonly showTooltip?: boolean;
  readonly thirdParty: FolderBusinessEntityListCmp_ThirdParty;
}

export const ActorAvatar = ({
  categoriesLabel,
  showTooltip = true,
  thirdParty,
}: Readonly<Props>) => {
  const label = thirdPartyTooltipOf(
    getThirdPartyName(thirdParty),
    categoriesLabel,
  );

  switch (thirdParty.__typename) {
    case 'Organization':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ThirdPartyTypeEnum.Organization:
      return (
        <Avatar
          bgColor={thirdParty.color}
          icon={<BusinessIcon />}
          imageUri={thirdParty.logoImageUri}
          label={label}
          showTooltip={showTooltip}
        />
      );
    case 'Person':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ThirdPartyTypeEnum.Person:
      return (
        <Avatar
          bgColor={thirdParty.color}
          fullName={thirdParty.fullName}
          imageUri={thirdParty.pictureImageUri}
          label={label}
          showTooltip={showTooltip}
        />
      );
    default:
      throw new Error('Unknown third party type');
  }
};
